<template>
  <header
    ref="commonHeader"
    class="common-header top-common-header main-cl main-bg"
    :class="{ 'common-header-fixed': router === 'home' }"
    @mouseout="handMouseleave('')"
  >
    <!-- 主流板块 -->
    <div>
      <ul class="common-header-linkList">
        <!-- logo -->
        <li class="linkList-logo-li">
        </li>
        <!--行情、现货、法币、合约-->
        <li
          v-for="(item, index) in tradesList"
          :key="index"
          class="header-navEven"
          :class="getClass(item.activeId)"
          @mouseenter="evenHandMouseenter(item.activeId)"
          @mouseleave="evenHandMouseleave"
          @click="btnLink(item.link)"
        >
          {{ item.title }}
          <i
            v-if="item.activeId === activeHeader || item.activeId === hoverHeader"
            class="hader-navActive blue-bg"
          ></i>
        </li>
      </ul>
      <!-- 公共版款 -->
      <div class="common-header-optionList">
        <!-- 未登录时 -->
        <div class="header-guide" v-if="!isLogin && userInfoIsReady">
          <button class="main-cl header-login-button" @click="btnLink('/login')">
            {{ $t("header.login") }}
          </button>
          <button class="white-cl blue-bg header-reg-button" @click="btnLink('/register')">
            {{ $t("header.register") }}
          </button>
        </div>
        <div class="header-isLogin" v-if="isLogin && userInfoIsReady">
          <!-- 资产 -->
          <div
            class="header-isLogin-navEven"
            :class="getClass('assets')"
            @mouseenter="evenHandMouseenter('assets')"
            @mouseleave="evenHandMouseleave"
          >
            <a-tooltip placement="bottom" :arrowPointAtCenter="true">
              <div class="header-isLogin-navEven-title" @click="btnLink('/assets/account')">
                {{ $t("header.assets") }}
                <i
                  v-if="'assets' === hoverHeader || 'assets' === activeHeader"
                  class="hader-navActive blue-bg"
                ></i>
              </div>
              <template slot="title">
                <ul class="list-content">
                  <li
                    v-for="(item, index) in assetsList"
                    :class="hoverMark === item.link ? 'blue-cl' : ''"
                    @mouseenter="markMouseenter(item.link)"
                    @mouseleave="markMouseleave"
                    @click="btnLink(item.link)"
                    :key="index"
                  >
                    {{ item.title }}
                  </li>
                </ul>
              </template>
            </a-tooltip>
          </div>
          <!-- 订单 -->
          <div
            class="header-isLogin-navEven"
            :class="getClass('order')"
            @mouseenter="evenHandMouseenter('order')"
            @mouseleave="evenHandMouseleave"
          >
            <a-tooltip placement="bottom" :arrowPointAtCenter="true">
              <div class="header-isLogin-navEven-title" @click="btnLink('/order/exchangeOrder')">
                {{ $t("header.order") }}
                <i
                  v-if="'order' === hoverHeader || 'order' === activeHeader"
                  class="hader-navActive blue-bg"
                ></i>
              </div>
              <template slot="title">
                <ul class="list-content">
                  <li
                    v-for="(item, index) in orderList"
                    :class="hoverMark === item.link ? 'blue-cl' : ''"
                    @mouseenter="markMouseenter(item.link)"
                    @mouseleave="markMouseleave"
                    @click="btnLink(item.link)"
                    :key="index"
                  >
                    {{ item.title }}
                  </li>
                </ul>
              </template>
            </a-tooltip>
          </div>
        </div>
        <!-- 个人中心 -->
        <div class="header-user header-user-box" v-if="isLogin && userInfoIsReady">
          <a-tooltip placement="bottom" :arrowPointAtCenter="true">
            <div class="user-box main-cl" @click="btnLink('/personal/userManagement')">
              <svg-icon iconClass="user" className="icon-16"></svg-icon>
              <span>{{ userText }}</span>
            </div>
            <template slot="title">
              <div class="user-content">
                <p
                  clas="user-info"
                  style="cursor: pointer"
                  @click="btnLink('/personal/userManagement')"
                >
                  {{ userText }}
                </p>
                <p class="user-status gray-cl">{{ $t("header.userStatus") }}：{{ userStatus }}</p>
                <c-button width="140px" style="font-size: 16px; padding: 0" @click="out">{{
                  $t("header.out")
                }}</c-button>
              </div>
            </template>
          </a-tooltip>
        </div>
        <!-- 消息中心 -->
        <div class="header-user message-tooltip" v-if="isLogin && userInfoIsReady">
          <div class="messageCount red-bg" v-if="messageCount"></div>
          <div @click="btnLink('/mesage')" v-if="userMessageList && !userMessageList.length">
            <svg-icon iconClass="notification" className="icon-16"></svg-icon>
          </div>
          <a-tooltip
            v-else
            placement="bottomRight"
            :arrowPointAtCenter="true"
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          >
            <div @click="btnLink('/mesage')">
              <svg-icon iconClass="notification" className="icon-16"></svg-icon>
            </div>
            <template slot="title">
              <div v-show="messageCount">
                <ul class="message-content">
                  <li
                    v-for="(item, index) in userMessageList"
                    :key="index"
                    :class="hoverMessage === index ? 'blue-cl' : ''"
                    @mouseenter="messageMouseenter(index)"
                    @mouseleave="messageMouseleave"
                    @click="btnLink('/mesage')"
                  >
                    {{ item.messageContent }}
                  </li>
                </ul>
                <p class="blue-cl message-more" @click="btnLink('/mesage')">
                  {{ $t("header.more") }}
                  <svg-icon iconClass="arrow-right" className="icon-14 message-icon"></svg-icon>
                </p>
              </div>
            </template>
          </a-tooltip>
        </div>
        <!-- app下载 -->
        <div class="header-user">
          <a-tooltip placement="bottom" :arrowPointAtCenter="true">
            <div><svg-icon iconClass="download" className="icon-16"></svg-icon></div>
            <template slot="title">
              <div class="download-content">
                <!-- <img class="download-code" src="@/assets/img/qrCode.png" /> -->
                <c-download-qrcode></c-download-qrcode>
                <p class="download-text">{{ $t("appDownLoad.headerCode") }}</p>
                <c-button
                  width="140px"
                  style="font-size: 16px; padding: 0"
                  @click="btnLink('/download')"
                  >{{ $t("appDownLoad.moreDown") }}</c-button
                >
              </div>
            </template>
          </a-tooltip>
        </div>
        <!-- 多语言 -->
        <div class="header-user">
          <a-tooltip placement="bottom" :arrowPointAtCenter="true">
            <div><svg-icon iconClass="language" className="icon-16"></svg-icon></div>
            <template slot="title">
              <ul class="list-content">
                <li
                  v-for="(item, index) in langArr"
                  :class="lan === item.id || langHover === item.id ? 'blue-cl' : ''"
                  @mouseenter="handMouseenter(item.id)"
                  @mouseout="handMouseleave(item.id)"
                  @click="lanClick(item.id)"
                  :key="index"
                >
                  {{ item.name }}
                </li>
              </ul>
            </template>
          </a-tooltip>
        </div>
        <!-- 涨跌颜色设置 -->
        <div class="header-user" v-if="upDownColors.length > 1">
          <div @click="setUpDownColors">
            <svg-icon iconClass="set" className="icon-16"></svg-icon>
          </div>
        </div>
        <!--主题-->
        <div class="header-user main-cl">
          <span v-if="Dskin == 1" @click="setConfirm(2)">
            <svg-icon iconClass="switch-sun" className="icon-16"></svg-icon>
          </span>
          <span v-else-if="Dskin == 2" @click="setConfirm(1)">
            <svg-icon iconClass="switch-moon" className="icon-16"></svg-icon>
          </span>
          <span v-else @click="setAlert">
            <svg-icon iconClass="set" className="icon-16"></svg-icon>
          </span>
        </div>
      </div>
    </div>

    <!--主题设置-->
    <c-dialog
      :showFlag="showFlag"
      :titleText="$t('header.set')"
      @confirm="setConfirm"
      @close="setClose"
    >
      <div class="setBox">
        <div class="setColor clearfix">
          <div class="setColor-key x-2-cl">{{ $t("header.color") }}</div>
          <ul class="setColor-value">
            <li v-for="(item, i) in colorList" :key="i">
              <c-redio @click="setSkin(item.skinId)" :value="Dskin === item.skinId" />
              <template v-if="item.skinName && item.skinName[lan]">
                <span @click="setSkin(item.skinId)" class="b-1-cl">
                  {{ item.skinName[lan] }}
                </span>
              </template>
              <template v-else>
                <span @click="setSkin(item.skinId)" class="b-1-cl">
                  {{ item.mainClor }}
                </span>
              </template>
            </li>
          </ul>
        </div>
      </div>
    </c-dialog>
    <!--涨跌颜色设置-->
    <c-dialog
      :showFlag="showColorDialog"
      :titleText="$t('header.set')"
      @confirm="setColor"
      @close="showColorDialog=false"
    >
      <div class="set-color-mode-box">
        <div class="clearfix">
          <div class="main-cl set-color-mode-title">{{ $t("header.up_down_color") }}</div>
          <ul class="">
            <li v-for="(item, i) in upDownColors" :key="i">
              <c-redio @click="colorMode=item.value" :value="colorMode === item.value" />
              <span @click="colorMode=item.value" class="b-1-cl">
                {{ item.label }}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </c-dialog>
  </header>
</template>

<script>
import {
  imgMap, setCookie, getCookie, myStorage,
} from '@/utils';
import { setUpDownMode, getUpDownMode } from '@/utils/storage';

export default {
  name: 'c-header',
  data() {
    return {
      outFlag: true,
      langHover: '', // 语言滑过
      langHoverSub: null,
      showFlag: false, // 设置主题弹窗变量
      showColorDialog: false, // 设置涨跌颜色弹框
      userSkin: getCookie('cusSkin') || getCookie('defSkin'), // 用户选择的skin
      hoverHeader: '', //
      activeHeader: '',
      hoverMark: '',
      activeMark: '',
      extensionPosition: {},
      hoverMessage: -1, // 消息划过
      colorMode: getUpDownMode(),
      upDownColors: [
        { label: this.$t('header.red_up_green_down'), value: 'red_up_green_down' }, // 红涨绿跌
        { label: this.$t('header.green_up_red_down'), value: 'green_up_red_down' }, // 绿涨红跌
      ],
    };
  },
  computed: {
    fiatTradeOpen() {
      const base = this.$store.state.baseData.publicInfo;
      if (base && base.switch && base.switch.fiat_trade_open === '1') {
        return true;
      }
      return false;
    },
    symbolAll() {
      return this.$store.state.baseData.symbolAll;
    },
    // 全部币种列表
    coinList() {
      if (this.$store.state.baseData && this.$store.state.baseData.market) {
        return this.$store.state.baseData.market.coinList;
      }
      return null;
    },
    // market 接口
    market() {
      return this.$store.state.baseData.market;
    },
    etfNavigationSwitch() {
      let flag = false;
      if (
        this.publicInfo
        && this.publicInfo.switch
        && this.publicInfo.switch.etfNavigationSwitch
        && this.publicInfo.switch.etfNavigationSwitch.toString() === '1'
      ) {
        flag = true;
      }
      return flag;
    },
    etfHave() {
      let flag = false;
      if (this.market && this.market.market.ETF && Object.keys(this.market.market.ETF).length) {
        flag = true;
      }
      return flag;
    },
    etfOpen() {
      if (this.etfNavigationSwitch && this.etfHave) {
        return true;
      }
      return false;
    },
    tradesList() {
      const arr = [];
      // 行情
      arr.push({
        title: this.$t('header.market'),
        activeId: 'market',
        link: this.headerLink.market,
      });
      arr.push({
        title: this.fiatTradeOpen ? this.$t('assets.b2c.otcShow.header') : this.$t('header.otc'),
        activeId: 'otcTrade',
        link: this.headerLink.otc,
      });
      arr.push({
        title: this.fiatTradeOpen ? this.$t('assets.b2c.otcShow.header') : this.$t('header.otc'),
        activeId: 'otcTrade',
        link: this.headerLink.otc,
      });
      return arr;
    },
    etfUrl() {
      let str = '';
      if (this.market) {
        const etfArr = [];
        Object.keys(this.market.market.ETF).forEach((ci) => {
          etfArr.push(this.market.market.ETF[ci]);
        });
        const symbol = etfArr.sort(this.compare('sort'))[0];
        const name = symbol.showName || symbol.name;
        str = name.replace('/', '_');
      }
      return `${this.headerLink.trade}/${str}`;
    },
    assetsList() {
      const arr = [];
      if (this.headerLink.co) {
        arr.push({
          title: this.$t('assets.index.coAccount'),
          link: '/assets/coAccount',
        });
      }

      arr.push({
        title: this.$t('assets.index.exchangeAccount'),
        link: '/assets/exchangeAccount',
      });

      const otcTitle = !this.fiatTradeOpen
        ? this.$t('assets.index.otcAccount')
        : this.$t('assets.b2c.otcShow.otcAccount');

      if (this.headerLink.otc) {
        arr.push({
          title: otcTitle,
          link: '/assets/otcAccount',
        });
      }
      return arr;
    },
    orderList() {
      const arr = [];
      if (this.headerLink.co) {
        arr.push({
          title: this.$t('order.coOrder.coOrder'),
          link: '/order/coOrder',
        });
      }
      if (this.headerLink.trade) {
        arr.push({
          title: this.$t('order.index.exOrder'),
          link: '/order/exchangeOrder',
        });
      }
      if (this.headerLink.otc) {
        arr.push({
          title: this.$t('order.index.otcOrder'),
          link: '/order/otcOrder',
        });
      }
      return arr;
    },
    title() {
      const { indexHeaderTitle, lan } = this.$store.state.baseData;
      let title = '';
      if (getCookie('lan')) {
        const language = getCookie('lan');
        title = indexHeaderTitle[language] || '';
      } else {
        const language = lan ? lan.defLan : '';
        title = language ? indexHeaderTitle[language] : '';
      }
      return title;
    },
    appDownload() {
      return this.$store.state.baseData.app_download || '';
    },
    Dskin() {
      let str = '';
      if (this.userSkin) {
        str = this.userSkin;
      } else if (getCookie('defSkin') || getCookie('cusSkin')) {
        if (getCookie('cusSkin')) {
          str = getCookie('cusSkin');
        } else {
          str = getCookie('defSkin');
        }
      }
      return str;
    },
    colorList() {
      let arr = [];
      let skinType = [];
      if (this.publicInfo && this.publicInfo.skinType) {
        skinType = this.publicInfo.skinType;
      }
      if (this.publicInfo && skinType.length) {
        arr = skinType;
      } else if (this.publicInfo && this.publicInfo.skin && this.publicInfo.skin.listist) {
        arr = this.publicInfo.skin.listist;
      }
      return arr;
    },
    subNavisShow() {
      if (this.appDownload && this.appDownload.app_page_url) {
        return true;
      }
      if (this.publicInfo && this.publicInfo.switch.is_financing_open) {
        return true;
      }
      return false;
    },
    lan() {
      if (this.isLogin && this.$store.state.baseData && this.$store.state.baseData.lan) {
        return this.$store.state.baseData.lan;
      }
      return this.$i18n.locale;
    },
    showLan() {
      let str = '';
      if (this.langArr.length) {
        this.langArr.forEach((item) => {
          if (this.lan === item.id) {
            str = item.name;
          }
        });
      }
      return str;
    },
    messageCount() {
      if (this.$store.state.baseData.messageCount) {
        return this.$store.state.baseData.messageCount;
      }
      return null;
    },
    userMessageList() {
      if (this.$store.state.baseData.userMessageList) {
        return this.$store.state.baseData.userMessageList;
      }
      return null;
    },
    linkurl() {
      if (this.$store.state.baseData.publicInfo) {
        return this.$store.state.baseData.publicInfo.url;
      }
      return {};
    },
    headerLink() {
      return {
        home: '/',
        otc: '/otc',
      };
    },
    router() {
      return this.$route.name;
    },
    isLogin() {
      return this.$store.state.baseData.isLogin;
    },
    userInfoIsReady() {
      return this.$store.state.baseData.userInfoIsReady;
    },
    userInfo() {
      return this.$store.state.baseData.userInfo;
    },

    publicInfo() {
      return this.$store.state.baseData.publicInfo;
    },

    /**
     * 是否开启虚拟盘
     */
    isVirtualOpen() {
      return this.publicInfo && this.publicInfo.is_virtual_open === '1';
    },

    /**
     * 一期上线只有英文和中文,其他语言暂不考虑
     */
    langArr() {
      // if (this.publicInfo && this.publicInfo.lan) {
      //   return this.publicInfo.lan.lanList;
      // }
      return [
        { name: 'English', id: 'en_US' },
        { name: 'عربي', id: 'ar_SA' },
        { name: '简体中文', id: 'zh_CN' },
      ];
    },
    userText() {
      if (this.userInfo) {
        return this.userInfo.userAccount;
      }
      return '';
    },
    logoUrl() {
      let url = '';
      if (this.publicInfo && this.publicInfo.msg && this.publicInfo.msg.logoUrl) {
        url = this.publicInfo.msg.logoUrl || imgMap.logo;
        // 设置 标题栏的 icon 图标
        // const link = document.querySelector
        // ("link[rel*='icon']") || document.createElement('link');
        // link.type = 'image/x-icon';
        // link.rel = 'shortcut icon';
        // link.href = this.publicInfo.msg.iconUrl;
        // document.getElementsByTagName('head')[0].appendChild(link);
      }
      return url;
    },
    intLogoUrl() {
      let url = '';
      if (this.publicInfo && this.publicInfo.msg && this.publicInfo.msg.logoUrl) {
        url = this.publicInfo.msg.index_international_logo || imgMap.int_logo;
      }
      return url;
    },
    userStatus() {
      let str = '';
      if (this.userInfo && this.userInfo.accountStatus.toString()) {
        switch (this.userInfo.accountStatus.toString()) {
          case '0':
            str = this.$t('header.userStatus1'); // '正常';
            break;
          case '1':
            str = this.$t('header.userStatus2'); // '冻结交易，冻结提现';
            break;
          case '2':
            str = this.$t('header.userStatus3'); // '冻结交易 3冻结提现';
            break;
          default:
            break;
        }
      }
      return str;
    },
  },
  watch: {
    title() {
      this.modifyTilte();
    },
    $route: {
      handler() {
        this.setActive();
        this.setMarkActive();
      },
      // 深度观察监听
      deep: true,
    },
    market: {
      handler(v) {
        if (v) {
          this.setActive();
        }
      },
      // 深度观察监听
      deep: true,
    },
    router(router) {
      if (router !== null) {
        this.modifyTilte();
      }
    },
  },
  created() {
    this.setActive();
    this.setMarkActive();
  },
  mounted() {
    this.modifyTilte();
    const locale = localStorage.getItem('locale');
    if (locale === 'ar_SA') {
      document.documentElement.dir = 'rtl';
    } else {
      document.documentElement.dir = 'ltr';
    }
  },
  methods: {
    init() {
      this.setMarkActive();
      this.modifyTilte();
    },
    setAlert() {
      this.showFlag = true;
    },
    // 涨跌颜色设置
    setUpDownColors() {
      this.colorMode = getUpDownMode();
      this.showColorDialog = true;
    },
    // 设置涨跌颜色
    setColor() {
      setUpDownMode(this.colorMode);
      this.showColorDialog = false;
      window.location.reload();
    },
    setClose() {
      this.userSkin = '';
      this.showFlag = false;
    },
    lanClick(id) {
      // this.
      if (id === this.lan) {
        return;
      }
      // 如果是登录用户，调接口切换语言
      if (this.isLogin) {
        this.axios({
          url: this.$store.state.url.common.change_language,
          params: { language: id },
          method: 'post',
        }).then((res) => {
          if (Number(res.code) === 0) {
            console.log('切换成功');
          }
        });
      }
      // const lang = id === 'zh_CN' ? 'ar_SA' : 'en_US';
      localStorage.setItem('locale', id);
      setCookie('lan', id);
      console.log('id', id);
      if (id === 'ar_SA') {
        document.documentElement.dir = 'rtl';
      } else {
        document.documentElement.dir = 'ltr';
      }
      // this.$i18n.locale = id;
      // 这里直接刷新页面，因为有些内容的多语言配置是通过接口获取的
      // 比如：公共底部
      window.location.reload();
    },
    // 获取服务端自选币对
    getMySymbol() {
      return this.axios({
        url: 'optional/list_symbol',
        params: {},
        method: 'post',
      }).then((data) => {
        if (data.code === '0') {
          const mySymbol = data.data.symbols.filter(x => x !== '');
          myStorage.set('mySymbol', mySymbol);
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      });
    },
    handMouseenter(id, sub) {
      if (sub === 'sub') {
        this.langHoverSub = id;
      } else {
        this.langHover = id;
      }
      if (id === 'extension' && this.$refs.commonHeader) {
        const top = this.$refs.extension.offsetTop;
        const { height } = this.$refs.commonHeader.getBoundingClientRect();
        if (height - top > 350) {
          this.extensionPosition = { top: `${top + 20}px` };
        } else {
          this.extensionPosition = { bottom: `${height - top - 40}px` };
        }
      }
    },
    handMouseleave(sub) {
      if (sub === 'sub') {
        this.langHoverSub = '';
      } else {
        this.langHover = '';
      }
    },

    // 路由跳转
    btnLink(link) {
      if (link.indexOf('http') > -1) {
        window.location.href = link;
      } else {
        this.$router.push(link);
      }
    },

    btnHref(link, target, options) {
      if (options && options.trades) {
        if (options.id === this.activeHeader) {
          return;
        }
        if (options.id === 'exTrade' && this.etfOpen) {
          this.marketCurrent = myStorage.set('markTitle', '');
          // 获取当前币对
          this.symbolCurrent = myStorage.set('sSymbolName', '');
        }
      }
      const headerTitleList = Object.keys(this.headerLink);
      const currentTitle = headerTitleList
        .filter(x => (this.headerLink[x] === link ? x : ''))
        .join();
      // 点击首页行情和币币交易时拉取最新自选币对
      if (this.isLogin && (currentTitle === 'home' || currentTitle === 'trade')) {
        this.getMySymbol().finally(() => {
          if (target && target === 'black') {
            window.open(link);
          } else {
            window.location.href = link;
          }
        });
      } else if (target && target === 'black') {
        window.open(link);
      } else {
        window.location.href = link;
      }
    },
    // 退出登录
    out() {
      if (!this.outFlag) {
        return;
      }
      this.outFlag = false;
      this.axios({
        url: 'user/login_out',
      }).then((data) => {
        this.outFlag = true;
        if (data.code.toString() === '0') {
          this.$bus.$emit('tip', { text: data.msg, type: 'success' });
          this.$bus.$emit('outUserIsLogin');
        } else {
          // this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      });
    },
    getClass(v) {
      let str = '';
      if (v === this.activeHeader || v === this.hoverHeader) {
        str = 'header-navEven-active';
      }
      return str;
    },
    setActive() {
      const { meta } = this.$route;
      const arr = ['otcTrade', 'marginTrade', 'assets', 'order'];
      let active = '';
      if (meta && meta.activeName && arr.indexOf(meta.activeName) !== -1) {
        active = meta.activeName;
      } else {
        const reg = /\/ex\/|\/otc\/|\/co\//g;
        let myPath = '';
        if (this.$route.path.match(reg)) {
          const Brr = this.$route.path.match(reg);

          myPath = `${this.$route.path.split(Brr[0])[1]}`;
        } else {
          myPath = this.$route.path.slice(1, this.$route.path.length);
        }
        active = myPath;
      }
      if (active === 'exTrade') {
        if (this.market && this.etfOpen && this.$route.params && this.$route.params.symbol) {
          const routeSymbol = this.$route.params.symbol;
          let symbolNameClassCion = routeSymbol.split('_')[0];
          let markTitleClassCion = routeSymbol.split('_')[1];
          const symbolNameClass = routeSymbol.split('_')[0];
          const markTitleClass = routeSymbol.split('_')[1];
          const coinLisArr = Object.keys(this.coinList);
          coinLisArr.forEach((item) => {
            const { showName } = this.coinList[item];
            if (showName === markTitleClass) {
              markTitleClassCion = item;
            }
            if (showName === symbolNameClass) {
              symbolNameClassCion = item;
            }
          });
          const symbol = `${symbolNameClassCion}/${markTitleClassCion}`;
          if (this.symbolAll[symbol] && this.symbolAll[symbol].etfOpen) {
            active = 'etf';
          }
        }
      }
      this.activeHeader = active;
    },
    setMarkActive() {
      const reg = /\/ex\/|\/otc\/|\/co\//g;
      let myPath = '';
      if (this.$route.path.match(reg)) {
        const arr = this.$route.path.match(reg);
        myPath = `/${this.$route.path.split(arr[0])[1]}`;
      } else {
        myPath = this.$route.path.slice(0, this.$route.path.length);
      }
      this.activeMark = myPath;
    },
    // title
    modifyTilte() {
      let routerName = this.$route.name;
      if (this.fiatTradeOpen && routerName === 'fiatdeal') {
        routerName = 'b2cFiatdeal';
      }
      let title = `${this.$t('pageTitle')[routerName] ? `-${this.$t('pageTitle')[routerName]}` : ''}`;
      if (this.title !== '') {
        title = `${this.title}${title}`;
      }
      document.title = title;
    },

    setConfirm(id) {
      setCookie('cusSkin', id || this.userSkin);
      window.location.reload();
    },

    setSkin(id) {
      this.userSkin = id;
    },

    evenHandMouseenter(v) {
      this.hoverHeader = v;
    },

    evenHandMouseleave() {
      this.hoverHeader = '';
    },

    markMouseenter(v) {
      this.hoverMark = v;
    },

    markMouseleave() {
      this.hoverMark = '';
    },

    // App 下载
    download(type) {
      window.open(this.appDownload[`${type}_download_url`]);
    },

    compare(property) {
      return function short(a, b) {
        const value1 = a[property];
        const value2 = b[property];
        return value1 - value2;
      };
    },

    messageMouseenter(v) {
      this.hoverMessage = v;
    },

    messageMouseleave() {
      this.hoverMessage = -1;
    },
  },
};
</script>

<style lang="scss" scoped>
.top-common-header {
  user-select: none;
  height: 64px;
  width: 100%;
  padding: 0 26px 0 40px;
  box-sizing: border-box;
  // border-bottom-width: 1px;
  // border-bottom-style: solid;
  position: relative;
  z-index: 11;
  a {
    font-size: 14px;
    height: 30px;
    line-height: 30px;
    // padding: 0px 12px;
    border-radius: 2px;
    display: inline-block;
  }
  // 涨跌颜色
  .set-color-mode-box {
    .set-color-mode-title {
      margin-bottom: 14px;
      font-size: 16px;
    }
    li {
      line-height: 20px;
      padding: 10px 0;
    }
  }
  // 修改主题
  .setBox {
    padding: 10px 0 0 0;
    .setColor-key {
      float: left;
      width: 110px;
      font-size: 14px;
    }
    .setColor-value {
      float: left;
      width: 290px;
      li {
        display: inline-block;
        margin-left: 50px;
        margin-top: 20px;
        &:nth-child(1),
        &:nth-child(2) {
          margin-top: 0px;
        }
        span {
          margin-left: 8px;
          cursor: pointer;
          font-size: 14px;
        }
      }
    }
  }
  // 主流板块
  .common-header-linkList {
    float: left;
    height: 64px;
    .header-navEven {
      line-height: 64px;
      float: left;
      margin-left: 28px;
      cursor: pointer;
      transition: all 0.3s;
      position: relative;
      .hader-navActive {
        width: 24px;
        height: 4px;
        position: absolute;
        left: 50%;
        bottom: 10px;
        transform: translateX(-50%);
        display: block;
      }
      .header-navEven-icon {
        width: 12px;
        height: 20px;
        position: absolute;
        right: -14px;
        top: 15px;
      }
      .new-label {
        position: absolute;
        right: -46px;
        top: 9px;
        box-shadow: -2px 2px 4px 0 rgba(0, 0, 0, 0.3);
        border-radius: 0px 6px 0px 6px;
        font-size: 10px;
        text-align: center;
        width: 44px;
        height: 17px;
        line-height: 17px;
      }
      &:hover {
        .header-navEven-list {
          display: block;
        }
      }
      .header-navEven-list {
        display: none;
        position: absolute;
        top: 64px;
        left: 0px;
        padding: 10px 0;
        box-shadow: 0 3px 4px 1px rgba(0, 0, 0, 0.28);
        li {
          cursor: pointer;
          text-align: left;
          min-width: 164px;
          padding: 0 20px;
          font-size: 14px;
          line-height: 40px;
          height: 40px;
          box-sizing: border-box;
        }
      }
    }
    // logo
    .linkList-logo {
      cursor: pointer;
      height: 30px;
      margin-top: 17px;
      // font-size: 130px;
      // transform: translateY(-33px);
    }
    .linkList-logo-li {
      float: left;
      img {
        width: 105px;
        height: 30px;
      }
    }
    // 更多
    .header-nav-ifl {
      cursor: pointer;
      position: relative;
      margin-right: 0 !important;
      padding-right: 16px !important;
      line-height: 64px;
      float: left;
      margin-left: 10px;
      .hover {
        display: none;
      }
      &:hover {
        .icon {
          display: none;
        }
        .hover {
          display: inline-block;
        }
        .header-sub-nav {
          display: block;
        }
      }
    }
    // 币币交易/法币交易
    .button-li {
      padding: 15px 0;
      .header-button-links {
        font-size: 14px;
        vertical-align: middle;
      }
    }
  }
  // 公共板块
  .common-header-optionList {
    float: right;
    .header-isLogin-navEven {
      height: 64px;
      float: left;
      margin-right: 28px;
      cursor: pointer;
      position: relative;
      .header-isLogin-navEven-title {
        transition: all 0.3s;
        line-height: 64px;
        position: relative;
        .hader-navActive {
          width: 24px;
          height: 4px;
          position: absolute;
          left: 50%;
          bottom: 10px;
          transform: translateX(-50%);
          display: block;
        }
      }
      &:hover {
        .lang-list {
          display: block;
        }
      }
      .lang-list {
        display: none;
        position: absolute;
        z-index: 2;
        top: 64px;
        left: -20px;
        padding: 10px 0;
        box-shadow: 0 3px 4px 1px rgba(0, 0, 0, 0.28);
        li {
          cursor: pointer;
          text-align: left;
          min-width: 164px;
          padding: 0 20px;
          font-size: 12px;
          line-height: 40px;
          height: 40px;
          box-sizing: border-box;
        }
      }
    }
    .header-isLogin {
      float: left;
      // padding: 15px 0;
      .header-isLogin-button {
        font-size: 14px;
        margin-right: 10px;
      }
    }
    .header-guide {
      float: left;
      // height: 64px;
      // padding: 15px;
      vertical-align: middle;
      // border-left-width: 1px;
      // border-left-style: solid;

      .header-login-button {
        font-size: 14px !important;
        margin-right: 28px;
        // padding: 0 22px;
        line-height: 64px;
      }
      .header-reg-button {
        font-size: 14px !important;
        margin-right: 14px;
        padding: 0 17px;
        height: 30px;
        border-radius: 4px;
        // border-width: 1px;
        // border-style: solid;
      }
    }
    .header-user {
      float: left;
      height: 64px;
      width: 44px;
      line-height: 64px;
      text-align: center;
      // border-left-width: 1px;
      // border-left-style: solid;
      position: relative;
      cursor: pointer;
      &:hover {
        .header-user-market,
        .header-user-message,
        .header-user-appdown,
        .icon-active {
          display: block;
        }
        .icon-info {
          display: none;
        }
      }
      .icon-active {
        display: none;
      }
      .header-user-market {
        padding-bottom: 10px;
      }
      .header-user-market,
      .header-user-appdown,
      .header-user-message {
        box-shadow: 0 3px 4px 1px rgba(0, 0, 0, 0.28);
        top: 64px;
        display: none;
        position: absolute;
        width: 240px;
        height: 120px;
        // left: -90px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 9999;
      }
      .header-user-message {
        height: auto;
        width: 320px;
        // right: -99px;
        // left: auto;
        min-height: 100px;
        .header-user-text {
          height: auto;
          li {
            height: 30px;
            line-height: 30px;
            overflow: hidden;
          }
          .mesageNav {
            cursor: pointer;
          }
        }
      }
      .header-user-icon {
        cursor: pointer;
      }
      .header-user-text {
        height: 80px;
        padding: 16px 22px;
        box-sizing: border-box;
        line-height: 24px;
        text-align: left;
        font-size: 12px;
        .userText {
          font-size: 14px;
          cursor: pointer;
        }
      }
      .header-user-out {
        height: 40px;
        padding: 0 22px;
        line-height: 40px;
        text-align: left;
        font-size: 12px;
        cursor: pointer;
      }
      .header-user-appdown {
        box-sizing: border-box;
        // left: auto;
        // right: 0;
        height: 177px;
        width: 210px;
        padding: 30px 40px;
        .code-box {
          float: left;
          .download-options-code {
            width: 90px;
            height: 90px;
            overflow: hidden;
            padding: 5px;
            background-color: #fff;
            img {
              width: 120px;
              position: relative;
              top: -10px;
              left: -10px;
            }
          }
          .download-options-codeText {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            line-height: 12px;
            color: #828ea1;
            letter-spacing: 0;
            text-align: center;
            margin-top: 10px;
          }
        }
        .download-options-buttons {
          float: right;
          button {
            line-height: 40px;
            display: block;
            width: 130px;
            &:first-child {
              margin-bottom: 10px;
            }
          }
        }
      }
    }
    .header-user-box {
      width: auto;
      font-family: "Medium";
      margin-right: 14px;
      .user-box {
        display: flex;
        align-items: center;
        height: 64px;
        span {
          margin-left: 4px;
        }
      }
    }
    .header-lang {
      float: left;
      height: 64px;
      min-width: 100px;
      line-height: 64px;
      text-align: center;
      // border-left-width: 1px;
      // border-left-style: solid;
      // font-size: 14px;
      position: relative;
      user-select: none;
      font-family: "Medium";
      .show-lang {
        cursor: pointer;
        padding: 0 14px;
        font-size: 14px;
        box-sizing: border-box;
      }
      &:hover {
        .lang-list {
          display: block;
        }
      }
      .lang-list {
        display: none;
        position: absolute;
        z-index: 2;
        top: 64px;
        right: 0px;
        padding: 10px 0;
        box-shadow: 0 3px 4px 1px rgba(0, 0, 0, 0.28);
        li {
          cursor: pointer;
          text-align: left;
          min-width: 164px;
          padding: 0 20px;
          font-size: 12px;
          line-height: 40px;
          height: 40px;
          box-sizing: border-box;
        }
      }
    }
  }
  .header-navEven-active {
    font-weight: bold;
  }
  .messageCount {
    position: absolute;
    width: 4px;
    height: 4px;
    border-radius: 8px;
    top: 25px;
    left: 24px;
    z-index: 10;
  }
  .header-sub-nav {
    display: none;
    position: absolute;
    width: 175px;
    left: 0;
    top: 64px;
    z-index: 99;
    padding: 10px 0;
    .header-user-text {
      padding: 0;
      box-sizing: border-box;
      text-align: left;
      font-size: 12px;
      li {
        float: none;
        margin: 0;
        padding: 0;
        span {
          line-height: 17px;
          padding: 12px 20px;
          font-size: 14px;
          display: block;
        }
      }
    }
  }
  .h-2-bd {
    border-color: #293448 !important;
  }
}
// 修改主题
.setBox {
  padding: 10px 0 0 0;
  .setColor-key {
    float: left;
    width: 100px;
    font-size: 14px;
  }
  .setColor-value {
    float: left;
    width: 300px;
    li {
      display: inline-block;
      margin-left: 50px;
      margin-top: 20px;
      &:nth-child(1),
      &:nth-child(2) {
        margin-top: 0px;
      }
      span {
        margin-left: 8px;
        cursor: pointer;
        font-size: 14px;
      }
    }
  }
}

.list-content {
  min-width: 140px;
  padding: 13px 0 15px;
  li {
    font-size: 16px;
    line-height: 22px;
    padding: 12px 20px;
    cursor: pointer;
    font-family: "Medium";
  }
}
.message-tooltip {
  .message-content {
    padding: 15px 0 30px;
    box-sizing: border-box;
    // max-width: 360px;
    max-width: 412px;
    li {
      // font-size: 13px;
      font-size: 16px;
      line-height: 26px;
      padding: 10px 20px;
      cursor: pointer;
      font-family: "Medium";
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: block;
      text-align: left;
    }
  }
  .message-more {
    padding-bottom: 20px;
    box-sizing: border-box;
    font-size: 16px;
    line-height: 26px;
    text-align: center;
  }
  .message-icon {
    margin-left: 8px;
    vertical-align: middle;
  }
}
.download-content,
.user-content {
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "Medium";
  .download-code {
    width: 140px;
    height: 140px;
  }
  .download-text {
    font-size: 14px;
    line-height: 22px;
    margin: 4px 0 8px;
  }
  .user-info {
    font-size: 16px;
    line-height: 26px;
    margin-top: 5px;
  }
  .user-status {
    font-size: 12px;
    line-height: 20px;
    margin: 8px 0 32px;
  }
}
.common-header-fixed {
  position: fixed;
  left: 0;
  top: 0;
}
</style>
